import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import language resources directly for synchronous loading
import enTranslations from '@/i18n/en.json'
import trTranslations from '@/i18n/tr.json'

// Initialize i18n with preloaded resources
const initI18n = () => {
  return i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: 'en',
      lng: 'en', // Default language
      debug: import.meta.env.DEV,

      interpolation: {
        escapeValue: false, // React already escapes
      },

      detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
      },

      resources: {
        en: {
          translation: enTranslations,
        },
        tr: {
          translation: trTranslations,
        },
      },
    })
}

// Initialize i18n and export the promise
export const i18nInitPromise = initI18n()

export default i18n 